/** */
import { urls } from 'services/_url';
import { apiGet, apiPut } from 'services/_http';

/** */
const base_url = `${urls.iam}/memberships`;

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const manage = async (action, options = {}) => {
  return await apiPut(`${base_url}/membership/${action}`, { ...options });
};

export const switchAccount = async (options = {}) => {
  return await apiPut(`${base_url}/accounts/switch`, { ...options });
};

export const updateById = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};
